(function () {
  function initLegacyProductEnhancements() {
    if (typeof window.jQuery !== 'function') return;
    var $ = window.jQuery;

    setTimeout(function () {
      var priceNode = $('.product-form__price h3');
      var price = priceNode.text();
      var amount = parseFloat((price || '').split('$').pop());

      if (!priceNode.length || !$('.button.button--primary.button--full.button--inline').length) return;
      if (!$('.price__btn23').length) {
        $('.product-form__price, .button.button--primary.button--full.button--inline')
          .wrapAll("<div class='price__btn23'></div>");
        $('.product-form .product-form__atc').css({
          'flex-direction': 'column',
          'padding-bottom': '10px'
        });
        $('.price__btn23').css('margin-bottom', '14px');
        $('.price__btn23').after(
          '<div class="pay_pal_btn23"><div data-pp-message data-pp-style-layout="text" data-pp-style-logo-type="primary" data-pp-style-text-color="white" data-pp-amount="' +
          (isFinite(amount) ? amount : '') +
          '"></div></div>'
        );
      }
    }, 1200);

    $('body').on('click.kaloudPayPal', function () {
      setTimeout(function () {
        var subtotalNode = $('.sidecart__subtotal--inner p.p-s:last-of-type');
        var subtotal = subtotalNode.text();
        var cartAmount = parseFloat((subtotal || '').split('$').pop());
        var target = $('.pay_pal_btn396');
        var caption = $('.sidecart__subtotal .caption-s.sidecart__subtotal--caption');

        if (!subtotalNode.length || !isFinite(cartAmount)) return;
        if ($('.paypal_msg_456').length) {
          $('.paypal_msg_456').remove();
          target.append('<div class="paypal_msg_456" data-pp-message data-pp-style-layout="text" data-pp-style-logo-type="alternative" data-pp-style-text-color="black" data-pp-amount="' + cartAmount + '"></div>');
        } else if (!target.length && caption.length) {
          caption.before('<div class="pay_pal_btn396"><div class="paypal_msg_456" data-pp-message data-pp-style-layout="text" data-pp-style-logo-type="alternative" data-pp-style-text-color="black" data-pp-amount="' + cartAmount + '"></div></div>');
        }
      }, 1200);
    });
  }

  if (typeof window.jQuery === 'function') {
    window.jQuery(initLegacyProductEnhancements);
  } else {
    window.addEventListener('load', initLegacyProductEnhancements, { once: true });
  }

  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (event) {
      var targetId = this.getAttribute('href').substring(1);
      var targetElement = document.getElementById(targetId);
      if (!targetElement) return;

      event.preventDefault();
      var header = document.querySelector('.Header');
      var headerOffset = header ? header.offsetHeight : 0;
      var elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;

      window.scrollTo({
        top: elementPosition - headerOffset,
        behavior: 'smooth'
      });
    });
  });
})();